import React, { Fragment } from 'react';
import axios from 'axios';
import { Segment, Button, Table, Loader, Popup, Header, Tab, Responsive } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { fetchSPStatuses, fetchStudyCycle, fetchTitles } from '../../Lookups/util';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema implementacija odabranog studijskog programa.</p>;

export default class StudentServiceImplStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyCycles: this.props.studyCycles ? this.props.studyCycles : [],
        };
    }

    UNSAFE_componentWillMount() {
        axios.all([fetchStudyCycle(), fetchTitles(), fetchSPStatuses()])
            .then(axios.spread((studyCycleRes, titlesRes, statusesRes) => {
                this.setState({
                    studyCycles: studyCycleRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    })),
                    SPStatuses: statusesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })),
                    titles: titlesRes.data
                });
            }));
    }

    render() {
        console.log('this.props.data', this.props.data);
        return (
            <div>
                <Fragment>
                    {this.props.data.length ?
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>
                                        R. br.
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Naziv implementacije
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Odsjek
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="2">
                                        Ciklus
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="2">
                                        <Header as="h4" image>
                                            <Header.Content>
                                                Trajanje
                                                <Header.Subheader>godine / semestri</Header.Subheader>
                                            </Header.Content>
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Titula
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="2">
                                        Napomena
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="2" />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.props.data.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.studyProgram.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.departments.map(e => (<div>{e.name}<br /></div>))}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="2">
                                        {el.studyCycles ? el.studyCycles.map(el => (<div>{el.displayName} <br /></div>)) : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="2">
                                        {el.studyProgram.durationYear} / {el.studyProgram.durationSemester}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.studyProgramTitle.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="2">
                                        {el.studyProgram.description}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle">
                                        <Link to={{ pathname: '/studijski-programi/implementacije/detalji', state: { implementation: el } }}>
                                            <Popup
                                                content="Detalji"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="align justify"
                                                        size="small"
                                                        onClick={() => localStorage.setItem('implementation', JSON.stringify(el))}
                                                        color="blue"
                                                    />}
                                            />
                                        </Link>
                                        <Link to={{ pathname: '/studijski-programi/implementacije/semestri', state: { implementation: el } }}>
                                            <Popup
                                                content="Semestri"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="copy outline"
                                                        size="small"
                                                        onClick={() => localStorage.setItem('implementation', JSON.stringify(el))}
                                                        color="green"
                                                    />}
                                            />
                                        </Link>
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : <NoDataMessage />
                    }
                </Fragment>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudentServiceImplStatus.js